import { atom } from 'jotai';

export const isProjectHeaderEditMode = atom<boolean>(false);

export const isProjectHeaderHovered = atom<boolean>(false);
